import { AuthState } from "@okta/okta-auth-js";

export default class BaseService {
    constructor() {}
    public readonly REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

    protected getHeaders(authState: AuthState | null = null): { headers: Record<string, string> } {
        if (!authState) {
            console.error("Auth state is null or undefined.");
            throw new Error("Auth state is not available.");
        }
        const token = authState?.accessToken?.accessToken;
        return {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        };
    }

    protected getHeadersMultipartFormData(authState: AuthState | null = null): { headers: Record<string, string> } {
        if (!authState) {
            console.error("Auth state is null or undefined.");
            throw new Error("Auth state is not available.");
        }
        const token = authState?.accessToken?.accessToken;
        return {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        };
    }
}